import classNames from 'classnames'
import Exchange from '@/assets/icons/Exchange'
import { i18n } from '@/locale/i18n'

// Market/Limit order type switcher shared by the place-bet panels
export default function OrderTypeToggle({ orderType, onChange, disabled = false }) {
  const options = [
    { value: 'market', label: i18n('place_bet.market') },
    { value: 'limit', label: i18n('place_bet.limit') },
  ]

  return (
    <div className="min-w-[70px]">
      <button
        onClick={() => {
          if (disabled) return
          const otherOption = options.find(option => option.value !== orderType)
          onChange(otherOption.value)
        }}
        disabled={disabled}
        data-testid="place-bet-order-type-toggle"
        data-state={orderType}
        className={classNames(
          'flex items-center w-full justify-between text-xs font-medium rounded-[var(--radius-sm)] h-8 transition-all duration-300 px-2',
          disabled
            ? 'cursor-not-allowed opacity-50 text-Neutral-4'
            : 'cursor-pointer text-Neutral-6 hover:bg-surface-3'
        )}
        type="button">
        <span className="text-xs font-medium">{options.find(option => option.value === orderType)?.label}</span>
        <Exchange width="12px" height="12px" fillcolor="currentColor" />
      </button>
    </div>
  )
}
